export * from './full-screen-slider.component';